import { useTranslation } from 'react-i18next';

import { buildAnalyticsRangeOptions, type AnalyticsRange } from '@/entities/analytics';
import { SegmentedControl } from '@/shared/ui';

export interface RangeToggleProps {
  value: AnalyticsRange;
  onChange: (range: AnalyticsRange) => void;
}

/**
 * Only 7 and 14 days are offered. Longer windows cost proportionally more
 * against the upstream analytics quota, so they stay closed until the data
 * lives in a store we own.
 */
export const RangeToggle = ({ value, onChange }: RangeToggleProps) => {
  const { t } = useTranslation('common');

  return (
    <SegmentedControl
      value={value}
      onValueChange={onChange}
      options={buildAnalyticsRangeOptions(t)}
      aria-label={t('analyticsDashboard.rangeToggle.dateRange')}
    />
  );
};
